import {$, w} from './constants';

const middle = window.matchMedia("(min-width: 1025px)");

const scroll = (middle) =>{
	if(middle.matches){
        console.log('scroll desktop');
        if($('#custom-scroll').length){
            const bar = new SimpleBar($('#custom-scroll')[0], {
                autoHide: false,
                classNames: {
                    content: 'simplebar-content',
                    scrollContent: 'simplebar-scroll-content',
                    scrollbar: 'simplebar-scrollbar',
                    track: 'simplebar-track'
                }
            });
        }
        if($('#custom-scroll-story').length){
            const bar = new SimpleBar($('#custom-scroll-story')[0], {
                autoHide: false,
                classNames: {
                    scrollContent: 'simplebar-scroll-content',
                    scrollbar: 'simplebar-scrollbar-story',
                    track: 'simplebar-track-story'
                }
            });
        }
	}else{
		console.log('scroll móvil');
	}
}

$(document).ready(function() {
    scroll(middle);
    middle.addListener(scroll);
})
